import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
var ModalIntegrationsClosingsComponent = /** @class */ (function () {
    function ModalIntegrationsClosingsComponent(dialogRef, data, formBuilder, snackBar, errorsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.errorsService = errorsService;
        console.log('data', data);
    }
    ModalIntegrationsClosingsComponent.prototype.cancel = function () {
        this.dialogRef.close('cancel');
    };
    ModalIntegrationsClosingsComponent.prototype.submit = function () {
        if (!this.formGroup.valid) {
            this.snackBar.open('Preencha corretamente os campos e tente novamente.');
            return false;
        }
        this.dialogRef.close(this.formGroup.value);
    };
    ModalIntegrationsClosingsComponent.prototype.ngOnInit = function () {
        this.formGroup = this.formBuilder.group({
            startDate: [null, [Validators.required]],
            dateEnd: [null, [Validators.required]],
        });
    };
    return ModalIntegrationsClosingsComponent;
}());
export { ModalIntegrationsClosingsComponent };
